import styled from "styled-components";

export const MobileSolutionHistoryWrapper = styled.div`
  padding: 58px 0 50px;
  overflow-y: auto;
  height: 100dvh;
  box-sizing: border-box;
`;

export const MobileSolutionHistoryBoarder = styled.div`
  width: 100%;
  height: 8px;
  background: var(--Black-100, #f0f0f0);
`;

export const MobileSolutionHistoryHeaderWrapper = styled.div`
  padding: 20px 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const MobileSolutionHistoryHeaderValue = styled.div`
  display: flex;
  flex-direction: column;
  color: #121212;
  gap: 5px;

  > .title {
    font-weight: 400;
    font-size: 15px;
    font-family: Pretendard;
  }

  > .point {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 20px;
  }
`;

export const MobileDropBoxWrapper = styled.div`
  position: relative;
`;

export const MobileDropBoxValue = styled.div`
  border: 1px solid var(--Black-200, #b7b7b7);
  height: 30px;
  border-radius: 15px;
  padding-top: 9px;
  padding-right: 8px;
  padding-bottom: 9px;
  padding-left: 12px;
  box-sizing: border-box;
  font-weight: 600;
  font-size: 12px;
  color: var(--Black-500, #202020);
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: center;
`;

export const MobileDropBoxOptionWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px;
  box-sizing: border-box;
  overflow-y: auto;
  right: 0;
  top: 36px;
  z-index: 105;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
`;

export const MobileDropBoxItem = styled.div<{ isSelected: boolean }>`
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  border: 1px solid var(--Black-100, #f0f0f0);
  color: ${(p) => (p.isSelected ? "#fff" : "var(--Black-500, #202020)")};
  background: ${(p) => (p.isSelected ? "var(--Purple-300, #6436e7)" : "#fff")};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
`;

export const MobileSolutionHistorySearchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 16px 12px;

  > .title {
    font-weight: 700;
    font-size: 20px;
  }
`;

export const MobileSolutionHistorySearch = styled.div`
  width: 188px;
  height: 30px;
  border-radius: 15px;
  padding: 5.5px 10px;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  background: #fff;

  > input {
    outline: none;
    width: 100%;
    height: 100%;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 10px;
    background: #fff;
    border: none;
    color: #121212;
  }

  > img {
    cursor: pointer;
  }
`;
